import CenterContainer from './CenterContainer'
import { useRouteError } from 'react-router'
import { useEffect } from 'react'
import { SectionHeading } from './ds/SectionHeading'
import { Button } from './ui/button'

export function ErrorPage() {
  const error = useRouteError()
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <CenterContainer>
      <img
        src="/ywc21/logo-compass.webp"
        alt=""
        aria-hidden
        width={488}
        height={319}
        className="mx-auto mb-6 h-20 w-auto"
      />
      <SectionHeading
        level={1}
        th="เกิดข้อผิดพลาด"
        en="Something went wrong"
        description="โปรดลองใหม่อีกครั้ง หากยังพบปัญหา ติดต่อทีมงานได้ทาง Facebook Page"
      />
      <Button className="mt-8" onClick={() => window.location.reload()}>
        ลองใหม่อีกครั้ง
      </Button>
    </CenterContainer>
  )
}
